(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["timer"] && !Shopify.designMode) return;
  try {
    
  class TimerBanner extends HTMLElement {
    connectedCallback() {
      this.settings = JSON.parse(this.querySelector(':scope > [type="application/json"]').innerText);
      this.section = this.closest('.shopify-section');
      this.days = this.querySelector('[data-days]');
      this.hrs = this.querySelector('[data-hours]');
      this.mins = this.querySelector('[data-minutes]');
      this.secs = this.querySelector('[data-seconds]');
      this.cdTimer(`timer-${this.settings.id}`);
    }
    cdTimer(name) {
      const cookieDeadline = this.getCookie(name);
      const initialDeadline = Date.now() + this.settings.time * 60000;
      const cookieExpire = new Date(initialDeadline + this.settings.expiry * 60000).toUTCString();
      const deadline = Number(cookieDeadline) || initialDeadline;
      if (!cookieDeadline) document.cookie = `${name}=${deadline};expires=${cookieExpire};path=/`;
      const updateClock = () => {
        const total = deadline - Date.now();
        const time = {
          days: Math.floor(total / (1000 * 60 * 60 * 24)),
          hrs: Math.floor((total / (1000 * 60 * 60)) % 24),
          mins: Math.floor((total / 1000 / 60) % 60),
          secs: Math.floor((total / 1000) % 60),
        };
        if (this.days) this.days.innerHTML = time.days > 0 ? `${('0' + time.days).slice(-2)}` : '';
        if (this.hrs) this.hrs.innerHTML = time.hrs > 0 ? `${('0' + time.hrs).slice(-2)}` : '';
        if (this.mins) this.mins.innerHTML = time.mins > 0 ? `${('0' + time.mins).slice(-2)}` : '';
        if (this.secs) this.secs.innerHTML = `${('0' + time.secs).slice(-2)}`;
        if (total <= 0 || isNaN(total)) {
          this.section.remove();
        } else {
          if (!this.timerLoaded) {
            this.section.setAttribute('active', '');
            this.timerLoaded = true;
          }
          setTimeout(updateClock, 1000 - (Date.now() % 1000));
        }
      };
      updateClock();
    }
    getCookie(name) {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? match[2] : null;
    }
  }
  customElements.define('timer-banner', TimerBanner);

  } catch(e) { console.error(e); }
})();
})();
